import axios from 'axios';
import { LOGIN_SUCCESS, LOGIN_FAILURE, SET_ALERT, LOGOUT_USER } from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const login = (username, password) => {
	return async (dispatch) => {
		try {
			const response = await axios.post(
				`${BASE_URL}/api/login-user`,
				{ email: username, password: password },
				{
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
					},
				}
			);
			dispatch({ type: LOGIN_SUCCESS, payload: response.data });
		} catch (error) {
			dispatch({ type: LOGIN_FAILURE, payload: error.message });
			dispatch({
				type: SET_ALERT,
				payload: { message: error.response?.data?.error || 'Login failed', status: 'error' },
			});
		}
	};
};

export const logout = () => {
	return async (dispatch) => {
		dispatch({ type: LOGOUT_USER });
	};
};
